import { render, staticRenderFns } from "./basegestiones.vue?vue&type=template&id=64ca3718"
import script from "./basegestiones.vue?vue&type=script&lang=js"
export * from "./basegestiones.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports